export const LANDING = {
  navLogo: "nav-logo",
  navApplyBtn: "nav-apply-btn",
  navWhatsappBtn: "nav-whatsapp-btn",
  heroApplyBtn: "hero-apply-btn",
  heroWhatsappBtn: "hero-whatsapp-btn",
  problemSection: "problem-section",
  equationSection: "equation-section",
  auditSection: "audit-section",
  benefitsSection: "benefits-section",
  audiencesSection: "audiences-section",
  formSection: "form-section",
  formNameInput: "form-name-input",
  formWebsiteInput: "form-website-input",
  formEmailInput: "form-email-input",
  formPhoneInput: "form-phone-input",
  formCompetitorsInput: "form-competitors-input",
  formSubmitBtn: "form-submit-btn",
  formWhatsappLink: "form-whatsapp-link",
  whatsappStickyBtn: "whatsapp-sticky-btn",
  footerWhatsapp: "footer-whatsapp",
  footerPhone: "footer-phone",
};
